import { CertificationType, CertificationUserTestQuestionType } from '@types'

import { ImmerStateCreator, StatusAction } from '../store.type'

import {
  GetCertificationsActionPayloadType,
  getCertificationsAction,
  getQuestionsRespondentAction,
  GetQuestionsRespondentActionPayloadType,
} from './certification.action'

/** StatusAction
 *
 ----------------------------- Lifecycle ----------------------------------
 IDLE => LOADING => SUCCEEDED or FAILED
 *
 */

export type CertificationSliceType = {
  /** selectors **/
  certificationsFiltered: CertificationType[]
  questionsRespondentFiltered: CertificationUserTestQuestionType[]
  /** actions **/
  getCertificationsAction: {
    call: (payload: GetCertificationsActionPayloadType) => void
    status: StatusAction
  }
  getQuestionsRespondentAction: {
    call: (payload: GetQuestionsRespondentActionPayloadType) => void
    status: StatusAction
  }
}

const certificationSlice: ImmerStateCreator<CertificationSliceType> = (set) => ({
  certificationsFiltered: [],
  questionsRespondentFiltered: [],
  /**  **/
  getCertificationsAction: {
    call: (payload) => getCertificationsAction(set)(payload),
    status: 'IDLE',
  },
  getQuestionsRespondentAction: {
    call: (payload) => getQuestionsRespondentAction(set)(payload),
    status: 'IDLE',
  },
})

export default certificationSlice
